export const timeListTableParams = (t) =>([
  {
    name: 'Time list',
    dataBase: 'time',
    //headerTextAlign: 'right',
    //contentTextAlign: 'right'
  },
        
]);
